import { useParams } from "react-router-dom";

import { PaginationProvider } from "../../providers/PaginationProvider/PaginationProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import { UnifiedSearchList } from "../../components/UnifiedSearchList";

export default function GroupTicketsPage() {
  const { uuid } = useParams();

  return (
    <PaginationProvider>
      <ModalProvider>
        <UnifiedSearchList uuid={uuid} />
      </ModalProvider>
    </PaginationProvider>
  );
}
